export default "__VITE_ASSET__BVBxi38r__"